<template>
  <div >
    <b-tabs>
      <b-tab title="Datos Derivacion" active>
        <b-card border-variant="light" >
          <b-row>
            <b-col>
              <b-card border-variant="light" >
                
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-user"> </i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Identificacion: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      {{ cita.paciente.persona.identificacion }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-user"> </i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Paciente: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      {{ cita.paciente.persona.primerNombre + " " + cita.paciente.persona.primerApellido }}
                    </b-col>
                  </b-row>
                </b-col>
              
                <b-col class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                        <i class="fas fa-stethoscope"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Doctor: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                        {{ cita.doctor.idPersona.primerNombre + " " + cita.doctor.idPersona.primerApellido }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                        <i class="fas fa-stethoscope"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Tipo de Atención:  </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      <b-form-radio-group
                v-model = "tipodeatencion" 
                :options = "optTipoAten">

                </b-form-radio-group>
                
                    </b-col>
                    </b-row>
                    </b-col>
                    <b-col class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                      <i class="fas fa-stethoscope"> </i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Cuadro Clinico: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                        <b-form-textarea v-model="cuadroclinico">

                        </b-form-textarea>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-stethoscope"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Especialidad Interconsulta:  </b>
                      </label>
                    </b-col>
                    
                    <b-col cols="6">
                      <v-select
                        v-model="derivacionespecialidad"
                        :options="opsEspecialidad"
                        label="descripcion"
                      >

                      </v-select>
                        
                    </b-col>
                  </b-row>
                </b-col>
                
              
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-stethoscope"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Hallazgos:  </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      <b-form-textarea v-model="hallazgos"/>
                    </b-col>
                    
              
                <b-col class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                        <i class="fas fa-stethoscope"></i>
                    </b-col>
                    <b-col cols="11">
                      <label>
                        <b> Diagnostico: </b>
                      </label>
                    </b-col>
                    
                    

                    </b-row>
                    <b-row>
                    <b-col cols="12">
                      <b-row>
                        <b-col  class="mb-1" cols="8" >
                          <v-select
                            placeholder="Escriba un diagnóstico..."
                            v-model="diagnosticosearch"
                            :options="opsDiagnosticos"
                            label="text"
                            @search="onSearchDiagnosticos"
                            :loading="isLoading"
                            :debounce="200"
                          /> 
                        </b-col>
                        <b-col class="mb-1" cols="4">
                          <b-form-radio-group v-model="tipoDiagnostico"
                          :options="optionsTipoDiagnostico" value-field="item"
                          text-field="name">  </b-form-radio-group>
                        </b-col>
                        <b-col class="mb-1" cols="2">
                          <b-form-checkbox v-model="diagesPrincipal" switch> <label>Principal</label> </b-form-checkbox>
                        </b-col>
                        <b-col class="mb-1 ml-2" cols="2">
                          <b-button @click="pushDiagnostico" variant="primary"> + </b-button>
                        </b-col>
                        <b-col cols="12">
                      <b-table
                      
                            :items="diagnosticos"
                            :fields="fieldsti"
                            small
                            responsive
                          >
                            <template #cell(tipo)="data">
                              {{ data.item.tipo }}
                            </template>
                            <template #cell(diagnostico)="data">
                              {{ data.item.diagnostico }}
                            </template>
                            <template #cell(principal)="data">
                              {{ data.item.principal ? "Sí" : "No" }}
                            </template>
                            <template #cell(acciones)="data">
                            
                              <b-button
                                variant="danger"
                                size="sm"
                                @click="removeItem(data.index)"
                                style="cursor: pointer"
                              >
                                <font-awesome-icon icon="circle-xmark" />
                              </b-button>
                            </template>
                          </b-table>
                        </b-col>
                    
                        </b-row>
                    
                    </b-col>
                  
                  </b-row>
                </b-col>
            
                  </b-row>
                </b-col>
              </b-card>
            </b-col>
            <b-col>
              <b-card border-variant="light">
                <b-col class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                        <i class="fas fa-pen"></i>
                    </b-col>
                    <b-col cols="5">
                      <label>
                        <b> Nivel de derivacion: </b>
                      </label>
                    </b-col>
                    <b-col cols="5">
                    <b-form-select
                    v-model="nivelseleccionado"
                    :options="niveles"
                    
                    
                  />
                  </b-col>
                
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                        <i class="fas fa-pen"></i>
                    </b-col>
                    <b-col cols="5">
                      <label>
                        <b> Es urgente?: </b>
                      </label>
                    </b-col>
                    <b-col cols="5">
                    <b-form-checkbox switch
                    v-model="esurgente"
                      
                  >
                    </b-form-checkbox>
                  </b-col>
                
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                        <i class="fas fa-barcode"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Motivo de Derivacion: </b>
                      </label>
                    </b-col>
                    
                    <b-col cols="6">
                      <v-select
                      v-model="motivoderivacion"
                      :options="opsMotivoDerivaciones"
                      label="text"
                    >
                    </v-select>
                    <b-form-input
                      class="mt-1"
                      v-model="motivoderivacionotro"
                      v-if="
                        motivoderivacion
                          ? motivoderivacion.value === 6
                          : motivoderivacion
                      "
                      placeholder="Describa otra.."
                    ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                        <i class="fas fa-barcode"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Tipo de Derivacion: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      <v-select
                      v-model="tipoderivacion"
                      :options="opsTipoDerivaciones"
                      label="text"
                    >
                    </v-select>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                        <i class="fas fa-calendar"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Fecha de Derivacion: </b>
                      </label>
                      </b-col>
                      <b-col cols="6">
                        <b-form-datepicker
                            v-model="fechaDerivacion"
                          
                            >
                          </b-form-datepicker> 
                        
                    </b-col>
                  </b-row>
                </b-col>
            
                <b-col  class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                      <i class="fas fa-stethoscope"></i>
                    </b-col>
                
                    <b-col cols="3">
                    
                      <label>
                        <b> Atencion Medica: </b>
                      </label>
                    </b-col>
                    <b-col class="mb-1" cols="5">
                    <v-select
                      v-model="searchAten"
                      :options="opsAtenciones"
                      label="text"
                      placeholder="Busque por codigo o descripcion.."
                      @search="onSearchAten"
                    ></v-select>
                  </b-col>
                  <b-col class="mb-1" cols="3">
                    <b-button variant="primary" @click = "pushAtencion"> + </b-button>
                  </b-col>
                    <b-col v-if="itemate" cols="12">
                      <b-table
                                :items="itemate"
                                :fields="fieldsate"
                                small
                                responsive
                              >
                                <template #cell(atencion)="data">
                                  {{ data.item.atencion }}
                                </template>
                                <template #cell(acciones)="data">
                            
                            <b-button
                              variant="danger"
                              size="sm"
                              @click="removeItemAten(data.index)"
                              style="cursor: pointer"
                            >
                              <font-awesome-icon icon="circle-xmark" />
                            </b-button>
                          </template>
                                </b-table>
                  
                    </b-col>
                  </b-row>
                </b-col>
                <b-col  class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                      <i class="fas fa-stethoscope"></i>
                    </b-col>
                
                    <b-col cols="3">
                      <label>
                        <b> Procedimiento: </b>
                      </label>
                    </b-col>
                    <b-col class="mb-1" cols="5">
                    <v-select
                      v-model="searchProc"
                      :options="opsProcedimientos"
                      label="text"
                      placeholder="Busque por codigo o descripcion.."
                      @search="onSearch"
                    ></v-select>
                  </b-col>
                  <b-col class="mb-1" cols="3">
                    <b-button variant="primary" @click = "pushProcedimiento"> + </b-button>
                  </b-col>
                    <b-col v-if="itempro"cols="12">
                      <b-table
                                :items="itempro"
                                :fields="fieldspro"
                                small
                                responsive
                              >
                                <template #cell(procedimiento)="data">
                                  {{ data.item.procedimiento }}
                                </template>
                                <template #cell(acciones)="data">
                            
                            <b-button
                              variant="danger"
                              size="sm"
                              @click="removeItemPro(data.index)"
                              style="cursor: pointer"
                            >
                              <font-awesome-icon icon="circle-xmark" />
                            </b-button>
                          </template>
                              </b-table>
                              
                    
                    </b-col>
                  </b-row>
                </b-col>
                <!-- <b-col class="my-1" cols="12">
                    <b-row>
                    <b-col cols="1">
                        <i class="fas fa-building"></i>
                    </b-col>
                    <b-col cols="5">
                      <label>
                        <b> Establecimiento: </b>
                      </label>
                    </b-col>
                    <b-col cols="5">
                        {{ cita.establecimiento.Descripcion }}
                    </b-col>
                  </b-row>
                </b-col> -->
            
              </b-card>
              
            </b-col>
          </b-row>
          
          
        </b-card>
      </b-tab>

      <b-tab v-if="contraref && infotecnica" title="Contra Ref/ Inf Tenica"> 
        <b-card>
          <b-row  >
            <b-col v-if = "contraref" cols="12">
              <b-row>
                <b-col cols="12">
                  <h5>Contra Referencia:</h5>
                </b-col>
                <b-col cols="6">
                  <label>Tratamientos Terapeuticos:</label>
                  <b-form-textarea v-model="contraref.tratera"/>                  
                </b-col>
                <b-col cols="6">
                  <label>Tratamiento Recomendado:</label>
                  <b-form-textarea v-model="contraref.tratareco"/>              
                </b-col>
              </b-row>
            </b-col>

            
            <b-col v-if = "infotecnica" class = "mt-2" cols="12">
              <b-row> 
                <b-col > 
                  <h5>Informacion Tecnica:</h5>
                </b-col>
            
                <b-col cols="6">
                  <label>Fecha informe:</label>
                  <b-form-datepicker v-model="infotecnica.fechait"/>
                </b-col>

                <b-col cols="6">
                  <label>Dirigido a:</label>
                  <b-form-textarea v-model="infotecnica.dirigidoa"/>
                </b-col>
                <b-col class="mt-1" cols="9">
                  <label>Observaciones:</label>
                  <b-form-textarea v-model="infotecnica.observaciones"/>                  
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>

      <b-tab v-if ="hispatologia" title="Hispatologia"> 
        <b-card>
          <b-row>
      
        </b-row>
          <b-row  >
            <b-col cols="6">
              <label>
                Tratamiento:

              </label>
              <b-form-textarea v-model = "hispatologia.tratamiento">

              </b-form-textarea>
              
            </b-col>
            <b-col cols="6">
              <label>
                Muestras:

              </label>
              <b-form-textarea v-model = "hispatologia.muestras">

  </b-form-textarea>
              
            </b-col>
            <b-col cols="12" class="mt-2">
              <label> <b>
                Datos citologia:
              </b>
              </label>
            
            </b-col>
            <b-col cols="6">
              <label>
                Material:

              </label>
              <b-form-checkbox-group
              v-model = "hispatologia.dcitologia.material"
              :options="optionsMaterial"
              >
              
              </b-form-checkbox-group>
              <b-form-input  v-model="hispatologia.dcitologia.materialotro" class="mt-1" v-if="hispatologia.dcitologia.material.includes('Otro')" placeholder="Describa otro..">

  </b-form-input>
            </b-col>
            <b-col cols="6">
              <label>
                Anticoncepcion:

              </label>
              <b-form-checkbox-group
              v-model = "hispatologia.dcitologia.antoconcepcion"
              :options="optionsaconcepcion"
              >

              </b-form-checkbox-group>
              <b-form-input class="mt-1" v-model="hispatologia.dcitologia.antoconcepcionotro" v-if="hispatologia.dcitologia.antoconcepcion.includes('Otro')" placeholder="Describa otro..">

              </b-form-input>
            </b-col>
            <b-col class="mt-1" cols="6">
              <label>
                <b>
                Edades:
                  </b>
              </label>
              <b-row>
                <b-col cols="6">
                  <label> Menarquia </label>
                  <b-form-area>
                    <b-form-input type="number" v-model="hispatologia.edad.menarquia ">
                    </b-form-input>
                  
                    
                  </b-form-area>
                </b-col>
                <b-col cols="6">
                  <label> Menopausia </label>
                  <b-form-area>
                    <b-form-input type="number" v-model="hispatologia.edad.menopausia"/>
                  </b-form-area>
                </b-col>
                <b-col cols="6">
                  <label> Inicio Sexual </label>
                  <b-form-area>
                    <b-form-input type="number" v-model="hispatologia.edad.isexual "/>                    
                  </b-form-area>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="mt-1" cols="6">
              <label>
                <b>Paridad:</b>
              </label>
              <b-row>
                <b-col cols="6">
                  <label> Gestaciones </label>
                  <b-form-area>
                    <b-form-input type="number" v-model="hispatologia.paridad.gestaciones "/>                    
                  </b-form-area>
                </b-col>
                <b-col cols="6">
                  <label> Partos </label>
                  <b-form-area>
                    <b-form-input type="number" v-model="hispatologia.paridad.partos "/>
                    
                  </b-form-area>
                </b-col>
                <b-col cols="6">
                  <label> Abortos </label>
                  <b-form-area>
                    <b-form-input type="number" v-model="hispatologia.paridad.abortos ">
                    </b-form-input>

                    
                  </b-form-area>
                </b-col>
                <b-col cols="6">
                  <label> Cesareas </label>
                  <b-form-area>
                    <b-form-input type="number" v-model="hispatologia.paridad.cesareas ">
                    </b-form-input>
                  
                  </b-form-area>
                </b-col>
              </b-row>
              
            </b-col>
            <b-col class="mt-1" cols="6">
              <label>
                <b>Fechas:</b>
              </label>
              <b-row>
                <b-col cols="6">
                  <label>Ultima Menstruacion: </label>
                
                  <flat-pickr
                    class="form-control"
                    v-model="hispatologia.fechas.umens"
                    locale="es"
                  />

                </b-col>
                <b-col cols="6">
                  <label>Ultimo Parto: </label>
                  <flat-pickr
                    class="form-control"
                    v-model="hispatologia.fechas.uparto"
                    locale="es"
                  />
                
                </b-col>
                <b-col cols="6">
                  <label>Ultima Citologia: </label>
                  <div class="flatpickr-container"> 
                    <flat-pickr
                      class="form-control"
                      v-model="hispatologia.fechas.ucito"
                      locale="es"
                    />
                  </div>
                </b-col>
              
              </b-row>
              
            </b-col>
            <b-col class="mt-1" cols="6">
              <label>Terapia hormonal:</label>
              <b-form-textarea v-model="hispatologia.terapiahormonal"/>
            </b-col>
          </b-row>
        
        </b-card>
      </b-tab>
      <div class="d-flex justify-content-end">
        <b-button 
          variant="primary" 
          @click="actualizarDerivacion"
        >
          Actualizar Derivacion
        </b-button>
      </div>
    </b-tabs>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BOverlay,
  BFormGroup,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormDatepicker,
  BFormRadioGroup,
  
} from "bootstrap-vue";
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import vSelect from "vue-select";
import { comprobarPermisos } from "@/shared/helpers";
import flatPickr from 'vue-flatpickr-component';
import _ from "lodash";


export default {
  components: {
    BCard,
    BFormDatepicker,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BOverlay,
    BLink,
    BBadge,
    vSelect,
    flatPickr,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormRadioGroup,
  },
  props: ['token'],
  
  data() {

    return {
      
        esurgente: null,
        optTipoAten: ["Consulta Externa", "Imagen", "Hospitalizacion", "Emergencia"],
        tipodeatencion: null,
        diagnosticosearch: null,
        diagesPrincipal: false,
        derivaciones: {},
        cita: {},
        optionsMaterial: ["Endocervix", "Exocervix", "Pared Vaginal", "Union Escamo Columnar", "Muñon Cervical", "Otro"],
        optionsaconcepcion: ["Oral", "Inyectable", "DIU", "ligadura", "Otro"],
        motivoderivacion: null,
        opsMotivoDerivaciones: [],
        motivoderivacionotro: null,
        fechaDerivacion: null,
        opsEspecialidad: null,
        tipoderivacion:null,
        opsTipoDerivaciones: [],
        derivacionespecialidad : null,
        tiposervicio : null,
        cuadroclinico : null,
        hallazgos: null,
        procedimiento: null,
        nivelseleccionado: null,
        diagnostico: null,
        atencionmedica: null,
        niveles: ["1", "2", "3"],
        searchAten: "",
        opsAtenciones: [],
        searchProc: "",
        opsProcedimientos: [],
        tipoDiagnostico: null,
        optionsTipoDiagnostico: [
          { item: '1', name: 'Presuntivo' },
          { item: '2', name: 'Definitivo' },
    
        ],
        opsDiagnosticos: [],
        searchQuery: null,
        isLoading: false,
        procedimientotext: null,
      atenciontext: null,
      diagnosticos: [],
      itempro: [],
      itemate: [],
      estadoderivacion: null,
      fieldspro: [
      {
          key: "codigo",
          label: "Codigo",
          thClass: "text-center",
        },
        {
          key: "procedimiento",
          label: "Descripcion",
          thClass: "text-center",
        },
        {
          key:"acciones",
          label: "Acciones",
          thClass: "text-center",
        }
      ],
      fieldsate: [
      {
          key: "codigo",
          label: "Codigo",
          thClass: "text-center",
        },
        {
          key: "atencion",
          label: "Descripcion",
          thClass: "text-center",
        },
        {
          key:"acciones",
          label: "Acciones",
          thClass: "text-center",
        }
      ],
      fieldsti: [
        { key: "tipo", label: "Tipo Diagnostico", thClass: "text-center" },
        { key: "codigo", label: "Codigo", thClass: "text-center" },

        {
          key: "diagnostico",
          label: "Descripcion/Codigo",
          thClass: "text-center",
        },
        { key: "principal", label: "Principal", thClass: "text-center" },
        { key: "acciones", label:"Acciones", thClass:"text-center"}
      ],

        
        


    }
  },
  created () {
    this.fetchEspecilidades();
    this.fetchTiposDerivaciones();
    comprobarPermisos(this.$route);
    this.fetchMotivosDerivaciones();
    this.debouncedGetDiagnosticos = _.debounce(this.selDiagnostico, 200);

    const tokenDerivacion = this.token
    console.log("este es el token de derivacion en ver", tokenDerivacion)
    this.fetchDerivaciones(tokenDerivacion);
    this.fetchProcedimientos()
    this.fetchAtenciones()
  },
  methods: {
  
    removeItem(index) {
      this.$swal({
        title: "¿Estás seguro de eliminar este ítem?",
        text: "¡No podrás revertir esta acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar!",
        cancelButtonText: "No, cancelar",
      })
        .then((result) => {
          if (result.isConfirmed) {
            this.diagnosticos.splice(index, 1);
            this.$store.dispatch("removeDiagnostico", index);
            this.$swal("Eliminado!", "El ítem ha sido eliminado.", "success");
          }
        })
        .catch((error) => {
          console.error("Error al eliminar el ítem:", error);
          this.$swal(
            "Error",
            "Ocurrió un error al intentar eliminar el ítem.",
            "error"
          );
        });
    },
    removeItemPro(index) {
      this.$swal({
        title: "¿Estás seguro de eliminar este ítem?",
        text: "¡No podrás revertir esta acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar!",
        cancelButtonText: "No, cancelar",
      })
        .then((result) => {
          if (result.isConfirmed) {
            this.itempro.splice(index, 1);
            
            this.$swal("Eliminado!", "El ítem ha sido eliminado.", "success");
          }
        })
        .catch((error) => {
          console.error("Error al eliminar el ítem:", error);
          this.$swal(
            "Error",
            "Ocurrió un error al intentar eliminar el ítem.",
            "error"
          );
        });
    },
    removeItemAten(index) {
      this.$swal({
        title: "¿Estás seguro de eliminar este ítem?",
        text: "¡No podrás revertir esta acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar!",
        cancelButtonText: "No, cancelar",
      })
        .then((result) => {
          if (result.isConfirmed) {
            this.itemate.splice(index, 1);
           
            this.$swal("Eliminado!", "El ítem ha sido eliminado.", "success");
          }
        })
        .catch((error) => {
          console.error("Error al eliminar el ítem:", error);
          this.$swal(
            "Error",
            "Ocurrió un error al intentar eliminar el ítem.",
            "error"
          );
        });
    },
    pushProcedimiento (){
     
      if (this.searchProc){
        let procedimiento = null
        let codigo = null
        
        if (this.searchProc.text) {
          procedimiento = this.searchProc.text
          codigo = this.searchProc.cod
           
        }
        
        const nuevoProcedimiento = {
        procedimiento : procedimiento ,
        codigo : codigo
      };
      console.log("estos es", nuevoProcedimiento)
      if (this.itempro === null ) {
          this.itempro = []
      } 
      this.itempro.push(nuevoProcedimiento);
      
        this.searchProc = []
      }
    },
    pushAtencion (){
      console.log("Hola estoy haciendo push")
      if (this.searchAten){
        let atencion = null
        let codigo = null
        
        if (this.searchAten.text) {
          atencion = this.searchAten.text
          codigo = this.searchAten.cod
           
        }
       
        const nuevaAtencion = {
        atencion : atencion, codigo : codigo
      };
      if (this.itemate === null ) {
          this.itemate = []
      } 
      this.itemate.push(nuevaAtencion);

        this.searchAten = []
      }
    },
    pushDiagnostico (){
      console.log("Hola estoy haciendo push")
      if (this.diagnosticosearch){
        let tipoDiagnostico = null
        
        if (this.tipoDiagnostico) {
           if (this.tipoDiagnostico === '1') {
            tipoDiagnostico ="Presuntivo"
           } 
           if (this.tipoDiagnostico === '2') {
            tipoDiagnostico ="Definitivo"
           }
            
           
        }
       
        const nuevoDiagnostico = {
        tipo: tipoDiagnostico,
        codigo: this.diagnosticosearch?.cod,
        diagnostico: this.diagnosticosearch?.text,
        principal: this.diagesPrincipal,
      };
      this.diagnosticos.push(nuevoDiagnostico);

      

      this.$store.dispatch("addDiagnostico", nuevoDiagnostico);
        
        this.diagnosticosearch = []
      }
    },
    async selDiagnostico(search) {
      if (search) {
        const query = `
                query getDiagnosticos($search: String!) { 
                    getDiagnosticos(search: $search) {
                        id
                        descripcion
                        codigo
                    }
                }
                `;
        try {
          const response = await axios.post(rutas.axios + "api", {
            query,
            variables: {
              search: search,
            },
          });
          this.opsDiagnosticos = response.data.data.getDiagnosticos.map(
            (item) => ({
              value: item.id,
              text: `${item.descripcion} (${item.codigo})`,
              cod: item.codigo
            })
          );
        } catch (error) {
          console.error("Error fetching Diagnostico", error);
        }
      } else {
        this.opsDiagnosticos = [];
      }
    },
    onSearchDiagnosticos(search, loading) {
      if (search.length > 2) {
        this.isLoading = true;
        loading(true);
        this.searchQuery = search;
        this.debouncedGetDiagnosticos(search);
      } else {
        this.opsDiagnosticos = [];
        this.isLoading = false;
      }
      loading(false);
    },
    onSearch(searchQuery) {
      this.searchProc = searchQuery; 
      
      if (this.searchProc.length >= 3) {
        this.fetchProcedimientos(); 
      }
      
    },
    onSearchAten(searchQuery) {
      this.searchAten = searchQuery; 
      if (this.searchAten.length >= 3) {     
        this.fetchAtenciones(); 
      }
      
    },
    async fetchProcedimientos() {
      const query = `
        query MyQuery($search: String!) {
          allProcs(search: $search) {
            message
            status
            total
            totalSns
            procedimiento {
              codigo
              descripcion
              precio
              id
              estado
            }
            procedimientosSns {
              id
              codigo
              descripcion
            }
          }
        }
      `;
      const variables = { search: this.searchProc };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });
        const allProcs = response.data.data.allProcs || {};
        const cartera = (allProcs.procedimiento || []).map((item) => ({
          value: item.id,
          text: `${item.descripcion} (${item.codigo})`,
          cod: item.codigo,
          source: "cartera",
        }));
        const sns = (allProcs.procedimientosSns || []).map((item) => ({
          value: `sns-${item.id}`,
          text: `${item.descripcion} (${item.codigo}) [SNS]`,
          cod: item.codigo,
          source: "sns",
        }));
        this.opsProcedimientos = [...cartera, ...sns];
      } catch (error) {
        console.error("Error fetching procedimientos:", error.response.data);
      }
    },
    async fetchAtenciones() {
      const query = `
                   query MyQuery ($search : String!){
  allCarteraAtencion(search: $search) {
    message
    status
    total
    atenciones {
      codTarifa
      descripcion
      id
    }
  }
}
        `;
      const variables = { search: this.searchAten };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });
        this.opsAtenciones =
          response.data.data.allCarteraAtencion.atenciones.map((item) => ({
            value: item.id,
            text: item.descripcion,
            cod : item.codTarifa 
          }));
      } catch (error) {
        console.error("Error fetching procedimientos:", error.response.data);
      }
    },
    async fetchTiposDerivaciones() {
        const query = `
                query MyQuery {
          allTipoderivacion {
            descripcion
            id
          }
        }
        `;
        try {
          const response = await axios.post(rutas.axios + 'api', { query });
          this.opsTipoDerivaciones = response.data.data.allTipoderivacion.map(item => ({
            value: item.id,
            text: item.descripcion,
          }));
        } catch (error) {
          
          console.error("Error fetching tipos de derivaciones:", error.response.data);
        }
      },
      async fetchMotivosDerivaciones() {
        const query = `
                query MyQuery {
          allMotivoderivacion {
            descripcion
            id
          }
        }
        `;
        try {
          const response = await axios.post(rutas.axios + 'api', { query });
          this.opsMotivoDerivaciones = response.data.data.allMotivoderivacion.map(item => ({
            value: item.id,
            text: item.descripcion,
          }));
        } catch (error) {
          
          console.error("Error fetching motivos de derivaciones:", error.response.data);
        }
      },
    async fetchEspecilidades() {
      const query = `
          query {
            allEspecialidad {
              id
              descripcion
            }
          }
        `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.opsEspecialidad = response.data.data.allEspecialidad.map(
          (item) => ({
            value: item.id,
            descripcion: item.descripcion,
          })
        );
      } catch (error) {
        console.error("Error fetching especialidades:", error.response.data);
      }
    },

    async actualizarDerivacion() {

      const query = `
      mutation ActualizarDerivacion(
        $tokenDerivacion: String!,
        $tipoAtencion: String,
        $tipoderivacionId: ID,
        $motivoderivacionId: ID,
        $fechaDerivacion: String,
        $nivelDerivacion: String,
        $especialidadInterconsulta: ID,
        $hallazgosDerivacion: String,
        $diagnosticoDerivacion: String,
        $procedimientoDerivacion: String,
        $atencionDerivacion: String,
        $contrareferencia: String,
        $informaciontecnica: String,
        $hispatologia: String,
        $estadoDerivacion: String,
        $cuadroClinico: String,
        $esurgente: String,
      
    ) {
      actualizarDerivacion(
        tokenDerivacion: $tokenDerivacion,
        tipoAtencion: $tipoAtencion,
        tipoderivacionId: $tipoderivacionId,
        motivoderivacionId: $motivoderivacionId,
        fechaDerivacion: $fechaDerivacion,
        nivelDerivacion: $nivelDerivacion,
        especialidad: $especialidadInterconsulta,
        hallazgosDerivacion: $hallazgosDerivacion,
        diagnosticoDerivacion: $diagnosticoDerivacion,
        procedimientoDerivacion: $procedimientoDerivacion,
        atencionDerivacion: $atencionDerivacion,
        contrareferencia: $contrareferencia,
        informaciontecnica: $informaciontecnica,
        hispatologia: $hispatologia,
        estadoDerivacion: $estadoDerivacion,
        cuadroClinico: $cuadroClinico,
        esurgente : $esurgente,
        
      ) {
        status
        message
        derivacion {
          id
          atenmedId {
            id
          }
          tipoderivacionId {
            id
          }
          motivoderivacionId {
            id
          }
          fechaDerivacion
          nivelDerivacion
          especialidad {
            id
          }
          hallazgosDerivacion
          diagnosticoDerivacion
          procedimientoDerivacion
          atencionDerivacion
          contrareferencia
          informaciontecnica
          hispatologia
          estadoDerivacion
          tipoAtencion
          estado
        }
      }
    }
`;

let motivoDerivacion = null
if ( this.motivoderivacion ){
  motivoDerivacion = this.motivoderivacion.value  
} else if ( this.derivaciones.motivoderivacionId ) {
  motivoDerivacion = this.derivaciones.motivoderivacionId.id
}

let tipoDerivacion = null

if (this.tipoderivacion){
  tipoDerivacion = this.tipoderivacion.value
} else if ( this.derivaciones.tipoderivacionId) {
  tipoDerivacion = this.derivaciones.tipoderivacionId.id
}

let especialidad = null
if (this.derivacionespecialidad) {
  especialidad = this.derivacionespecialidad.value
} else if (this.derivaciones.especialidadInterconsulta) {
  especialidad = this.derivaciones.especialidadInterconsulta.id
}

let atencion = null
if (this.itemate){
  if (this.itemate.length > 0) {
  atencion = JSON.stringify(this.itemate)
  }
}



let procedimiento = null
if (this.itempro) {
if (this.itempro.length > 0){
  procedimiento = JSON.stringify(this.itempro)
}
}
let diagnostico = null
if (this.diagnosticos) {
if (this.diagnosticos.length > 0){
  diagnostico = JSON.stringify(this.diagnosticos)
}
}
let urgente = '0'
if (this.esurgente === true) {
  urgente ='1'
}
const variables = {
  tokenDerivacion: this.token,
  tipoAtencion: this.tipodeatencion,
  tipoderivacionId: tipoDerivacion,
  motivoderivacionId: motivoDerivacion,
  fechaDerivacion: this.fechaDerivacion,
  nivelDerivacion: this.nivelseleccionado,
  especialidadInterconsulta: especialidad,
  hallazgosDerivacion: this.hallazgos,
  diagnosticoDerivacion: diagnostico,
  procedimientoDerivacion: procedimiento,
  atencionDerivacion: atencion,
  contrareferencia: JSON.stringify(this.contraref),
  informaciontecnica: JSON.stringify(this.infotecnica),
  hispatologia: JSON.stringify(this.hispatologia),
  estadoDerivacion: this.estadoderivacion,
  cuadroClinico : this.cuadroclinico,
  esurgente : urgente
  
}

try {
          const response = await axios.post(rutas.axios + 'api', {
            query: query,
            variables: variables
          });
  
          if (response.data.data.actualizarDerivacion.status === 'success') {
            this.$swal({
                                    title: 'Success',
                                    text: response.data.data.actualizarDerivacion.message,
                                    icon: 'success',
                                    confirmButtonColor: '#089599',
                                })
          } else {
            console.error("Error al obtener la derivacion medica:", response.data.message);
          }
        } catch (error) {
          console.error("Error al realizar la consulta GraphQL:", error);
        }
    },


    async fetchDerivaciones(tokenDerivacion, pagina_actual = 1,  pageSize) {
           
          
           const query = `
              query MyQuery($page:Int , $pageSize: Int, $search: String, $establecimiento: String, $tokenDerivacion: String) { 
                allDerivacionesenviadas(page: $page, pageSize: $pageSize, search: $search, establecimiento: $establecimiento, tokenDerivacion: $tokenDerivacion) {
                    message
                    status
                    total
                    derivaciones {
                    id
                    token
                    atenmedId {
                    cita {
                    paciente {
                        persona {
                        identificacion
                        primerNombre
                        primerApellido
                        }
                    }
                    
                    doctor {
                        idPersona {
                        primerNombre
                        primerApellido
                        }
                        especialidad {
                        descripcion
                        }
                    }
                    establecimiento {
                    Descripcion
                    }
                    }
                    }
                                motivoderivacionId {
                                id
                    descripcion
                  }
                     
                    tipoderivacionId {
                    id
                      descripcion
                    }
                      especialidad {
                      id
                        descripcion
                      }
                            fechaDerivacion
                  estadoDerivacion
                  cuadroClinico
                  hallazgosDerivacion
                  nivelDerivacion
                  informaciontecnica
                  hispatologia
                  atencionDerivacion
                  contrareferencia
                  diagnosticoDerivacion
                  procedimientoDerivacion
                  tipoAtencion
                  }
                 
                  

                    }
                }
                                         
           `;
           
           const variables = {
            tokenDerivacion: tokenDerivacion,
            page : pagina_actual,
            pageSize: pageSize
        };
  
        try {
          const response = await axios.post(rutas.axios + 'api', {
            query: query,
            variables: variables
          });
  
          if (response.data.data.allDerivacionesenviadas.status === 'Success') {
            if (response.data.data.allDerivacionesenviadas.derivaciones) {

            this.derivaciones = response.data.data.allDerivacionesenviadas.derivaciones[0]
            this.cita = response.data.data.allDerivacionesenviadas.derivaciones[0].atenmedId.cita;
            this.estadoderivacion = this.derivaciones.estadoDerivacion
            this.motivoderivacion = this.derivaciones.motivoderivacionId ? this.derivaciones.motivoderivacionId.descripcion : null 
            this.tipoderivacion = this.derivaciones.tipoderivacionId ? this.derivaciones.tipoderivacionId.descripcion : null 
            this.fechaDerivacion = this.derivaciones.fechaDerivacion  || null
            this.hallazgos = this.derivaciones.hallazgosDerivacion || "No disponible"
            this.nivelseleccionado = this.derivaciones.nivelDerivacion  || null
            this.derivacionespecialidad = this.derivaciones.especialidad ? this.derivaciones.especialidad : null
            this.itemate = this.derivaciones.atencionDerivacion ? JSON.parse(this.derivaciones.atencionDerivacion) : null;
            this.itempro = this.derivaciones.procedimientoDerivacion ? JSON.parse(this.derivaciones.procedimientoDerivacion) : null;
            this.tipodeatencion = this.derivaciones.tipoAtencion
            this.cuadroclinico = this.derivaciones.cuadroClinico || ''
            
            
            if (this.derivaciones.diagnosticoDerivacion) {
            let diagnosticos = JSON.parse(this.derivaciones.diagnosticoDerivacion)
            this.diagnosticos = diagnosticos

            } else {
              this.diagnosticos = []
            }
            this.procedimiento =
              this.derivaciones.procedimientoDerivacion || null;
            if (this.procedimiento) {
              for (let i = 0; i < this.opsProcedimientos.length; i++) {
                if (this.opsProcedimientos[i].value === this.procedimiento) {
                  this.procedimientotext = this.opsProcedimientos[i].text;
                  this.itempro.push({ procedimiento: this.procedimientotext });
                }
              }
            }
            if (this.derivaciones.hispatologia){
              let hispatologia = JSON.parse(this.derivaciones.hispatologia)
              this.hispatologia = hispatologia
            } else {
              this.hispatologia = null
            }
            if (this.derivaciones.contrareferencia){
              let contraref = JSON.parse(this.derivaciones.contrareferencia)
              this.contraref = contraref
            } else {
              this.contraref = null
            }
            if (this.derivaciones.informaciontecnica){
              let infotecnica = JSON.parse(this.derivaciones.informaciontecnica)
              this.infotecnica = infotecnica
            } else {
              this.infotecnica = null
            }
               
          }
          } else {
            console.error("Error al obtener la derivacion medica:", response.data.message);
          }
        } catch (error) {
          console.error("Error al realizar la consulta GraphQL:", error);
        }
      },
       
  }
};
</script>
<style>
.flatpickr-container input {
    padding: 0.438rem 1rem;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #d8d6de;
    border-radius: 0.357rem;
    display: block;
    width: 100%;
    height: 2.714rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.45;
    color: #6e6b7b;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>
